import {
  DECREMENT_UNREAD_COUNT,
  INCREMENT_UNREAD_COUNT,
  RESET_UNREAD_COUNT,
  SET_UNREAD_COUNT
} from './mutationTypes'

const mutations = {
  [SET_UNREAD_COUNT](state, count) {
    state.unreadCount = Math.max(0, Number(count) || 0)
  },

  [INCREMENT_UNREAD_COUNT](state) {
    state.unreadCount += 1
  },

  [DECREMENT_UNREAD_COUNT](state) {
    state.unreadCount = Math.max(
      0,
      state.unreadCount - 1
    )
  },

  [RESET_UNREAD_COUNT](state) {
    state.unreadCount = 0
  }
}

export default mutations
